import shave from "shave";

class LineClamp {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.contentElem = self.elem.querySelector('[data-line-clamp-content]');
        self.content = self.contentElem.innerHTML;
        self.toggle = self.elem.querySelector('[data-line-clamp-toggle]');
        self.clampedHeight = 70;
        self.isOpen = false;
    }

    init() {
        let self = this;

        // Reveal the toggle button
        self.toggle.classList.add('is-visible');

        // Set the clamped content height given the specified number of lines
        self.setClampedLineCount(3);

        // Apply line clamp on page load
        self.close();

        // List for toggle clicks
        self.toggle.addEventListener('click', evt => {
            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });
    }

    setClampedLineCount(lines) {
        let self = this;
        let compStyles = window.getComputedStyle(self.contentElem);
        let lineHeight = parseInt(compStyles.getPropertyValue('line-height'), 10);

        self.clampedHeight = lineHeight * lines;
    }

    open() {
        let self = this;

        self.contentElem.innerHTML = self.content;
        self.toggle.setAttribute('aria-expanded', true);

        self.isOpen = true;
    }

    close() {
        let self = this;

        shave(self.contentElem, self.clampedHeight);
        self.toggle.setAttribute('aria-expanded', false);

        self.isOpen = false;
    }
}

export default LineClamp;
